export function getTeamIdFromPlayer(player) {
    if (!player) {
        return null;
    }

    const { team, teamId } = player;

    if (typeof team === 'string' && team.trim() !== '') {
        return team;
    }

    if (team && typeof team === 'object') {
        const legacyKey = '\x5fid';
        const objectId = team.id ?? team[legacyKey];
        if (objectId) {
            return String(objectId);
        }
    }

    if (teamId && String(teamId).trim() !== '') {
        return String(teamId);
    }

    return null;
}
